<template><svg width="79" height="31" viewBox="0 0 79 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.4" d="M60.5001 0L78.2536 30.75H42.7466L60.5001 0Z" fill="#292D32"/>
<path opacity="0.4" d="M18.5001 0L36.2536 30.75H0.746582L18.5001 0Z" fill="#292D32"/>
<path opacity="0.4" d="M39.5001 31L21.7466 0.25H57.2536L39.5001 31Z" fill="#292D32"/>
</svg>
</template>